import object from '@mailobj-browser/front/js/utils/object.js'

const block = 'ea_generics__NEW'

export const elements = object(null, {
  new_field: `${block}_field`,
  new_field_control: `${block}_field_control`,
  new_field_input: `${block}_field_input`,
  new_field_select: `${block}_field_select`,
  new_field_select_group_icon: `${block}_field_select_group_icon`,
  new_fieldset: `${block}_fieldset`,
  new_fieldset_pattern: `${block}_fieldset_pattern`,
  new_fields: `${block}_fields`
})

export const modifiers = object(null, {
  new_field: object(null, {
    new_time: `${elements.new_field}-time`,
    new_select: `${elements.new_field}-select`,
    new_disabled: `${elements.new_field}-disabled`
  }),
  new_field_control: object(null, {
    new_conditional: `${elements.new_field_control}-conditional`,
  }),
  new_field_input: object(null, {
    new_checkbox: `${elements.new_field_input}-checkbox`,
    new_hidden: `${elements.new_field_input}-hidden`,
    new_password: `${elements.new_field_input}-password`,
    new_text: `${elements.new_field_input}-text`
  }),
  new_fieldset_pattern: object(null, {
    new_pattern_color: `${elements.new_fieldset_pattern}-color`,
    new_pattern_items: `${elements.new_fieldset_pattern}-items`,
    new_pattern_items_set: `${elements.new_fieldset_pattern}-items_set`,
    new_pattern_items_nb: `${elements.new_fieldset_pattern}-items_nb`,
    new_pattern_items_item: `${elements.new_fieldset_pattern}-items_item`,
    new_pattern_time_select: `${elements.new_fieldset_pattern}-time_select`,
  })
})
